import { Stack } from 'shared';
import React from 'react';
import { CalculationTooltip } from 'Sensors';
import { SensorStateIcon } from 'Sensors/components/SensorStateIcon';
import { SentryApiClient } from '_generated/api';

import styles from './SensorHeader.module.css';
import { SensorTypeToolTip } from 'Sensors/components/SensorTypeTooltip';
import { SiteThemeIcon } from 'Sites/components/SiteThemeIcon';
import { SiteThemeContextValue } from 'Sites/hooks/SiteThemeProvider';

interface ISensorHeader {
  sensorState?: SentryApiClient.SensorStateType;
  calculation?: string;
  sensorName?: string;
  sensorDescription?: string;
  tSenSActive?: boolean;
  prepend?: React.ReactNode;
}

const SensorHeader: React.FC<ISensorHeader> = ({
  sensorState,
  calculation,
  sensorName,
  sensorDescription,
  tSenSActive,
  prepend,
}) => {
  return (
    <Stack gap="sm" alignment="middle">
      {prepend}
      {sensorDescription}
      {sensorName && <span className={styles.sensorName}>{sensorName}</span>}
      <CalculationTooltip calculation={calculation} />
      <SensorTypeToolTip tSensActive={tSenSActive} />
      <SensorStateIcon state={sensorState} />
    </Stack>
  );
};

export { SensorHeader };
